module.exports = __webpack_public_path__ + "img/1F498.c0822bd8.svg";